/**
 * Auto-detects a visitor's country via Shopify's browsing_context_suggestions.json
 * and switches the storefront's active market (country/pricing) automatically,
 * on every visit, but only when the detected country matches one of the
 * markets configured in Shopify Admin. Any other country is left on the
 * shop's default market/currency.
 */
(function () {
  function submitCountryChange(countryCode) {
    var form = document.createElement('form');
    form.action = '/localization';
    form.method = 'POST';
    form.hidden = true;

    var methodInput = document.createElement('input');
    methodInput.name = '_method';
    methodInput.value = 'PUT';
    form.appendChild(methodInput);

    var countryInput = document.createElement('input');
    countryInput.name = 'country_code';
    countryInput.value = countryCode;
    form.appendChild(countryInput);

    document.body.appendChild(form);
    form.submit();
  }

  function init() {
    // Never run inside an iframe (e.g. the Shopify theme editor preview).
    // The editor's preview is cross-origin from admin.shopify.com, so a
    // cookie set here may not persist, which would otherwise cause this
    // script to re-trigger a form-submit navigation on every reload.
    if (window.top !== window.self) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var configEl = document.getElementById('GeoLocalizationSettings');
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    if (!config.endpoint || !config.currentCountry || !config.availableCountries) return;

    var url =
      config.endpoint +
      '?country[enabled]=true&country[exclude]=' +
      encodeURIComponent(config.currentCountry);

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        if (!data) return;

        var suggestion =
          (data.suggestions && data.suggestions[0] && data.suggestions[0].country) ||
          (data.detected_values && data.detected_values.country);

        var handle = suggestion && suggestion.handle;
        if (!handle) return;
        if (handle === config.currentCountry) return;

        // Only switch when the detected country belongs to a market that's
        // actually configured in Shopify Admin. Otherwise leave the shop on
        // its default market/currency (e.g. India / INR).
        if (config.availableCountries.indexOf(handle) === -1) return;

        submitCountryChange(handle);
      })
      .catch(function () {
        // Silently ignore network/API errors; visitor stays on default market.
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
